module.exports = __webpack_public_path__ + "static/media/velour3A.5215f6bd.jpg";